import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MeetingsService } from '@app/services/meetings/meetings.service';

import { InstitutionsService } from '@app/services/institutions/institutions.service';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { CSVDataService } from '@app/export/CSVDataService';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SortService } from '@app/components/sorting/SortService';

import { PermissionsService } from '@app/services/permissions/permissions.service';
import { AuthService } from '@app/services/auth/auth.service';
import { MenuItem } from 'primeng/api';
import { MemberService } from '@app/services/member.service';
import { Sort } from '@angular/material/sort';
import moment from 'moment';

interface Meeting {
  institutionId: number;
  fromDate: string;
  toDate: string;
  institutionVisitingAddressCity: string;
  issue: string;
  comment: string;
  meetingTypeId: string;
}

interface MeetingResult {
  id: number;
  meetingDate: string;
  issue: string;
  comment: string;
  meetingTypeName: string;
  institutionShortName: string;
  institutionName: string;
  institutionVisitingAddressCity: string;
  numberOfAttendances: number;
  numberOfOwnInstitutionAttendances: number;
  numberOfGuestAttendances: number;
}

interface LodgeAndCamp {
  id: number;
  shortname: string;
  name: string;
}

@Component({
  selector: 'app-meetingreport',
  templateUrl: './meetingreport.component.html',
  styleUrls: ['./meetingreport.component.css']
})
export class MeetingreportComponent implements OnInit {
  meetingform;
  
  roleid;
  institutiondata: LodgeAndCamp;
  addmeetingview = false;
  institutionlist: LodgeAndCamp[] = [];
  meetingresult: MeetingResult[] = [];
  csvdata: MeetingResult[] = [];
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  chooseninstitution: string;
  startDate = new Date().getFullYear() + '-01-01';
  currentdate = moment(this.startDate.valueOf()).format('YYYY-MM-DD');
  mobiledevice = false;
  items: MenuItem[];
  institutionid;
  role;

  can_edit_attendance = false;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private memberService: MemberService,
    private permissionService: PermissionsService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private meetingsService: MeetingsService,
    private institutionsService: InstitutionsService,
    private router: Router) {

    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });
  }

  setPermissions() {
    if (this.institutionid) {
      this.permissionService.hasPermissionForInstitution('EDIT_ATTENDANCE', this.institutionid).subscribe(p => {
        this.can_edit_attendance = p;
      });
    }
  }

  ngOnInit() {
    this.meetingform = this.fb.group({
      institutionId: [null, ''],
      fromDate: [null, ''],
      toDate: [null, ''],
      institutionVisitingAddressCity: [null, ''],
      issue: [null, ''],
      comment: [null, ''],
      meetingTypeId: [null, ''],
      roleId: [null, '']
    });
    
    this.activatedRoute.paramMap.subscribe(paramMap => {
      if (!paramMap.get('id')) {
        if (this.permissionService.selectedrole.getValue()?.institution.id) {
          this.institutionid = this.permissionService.selectedrole.getValue()?.institution.id;
          this.meetingform.patchValue({ institutionId: this.institutionid, fromDate: this.currentdate });
        }
      } else {
        this.institutionid = +paramMap.get('id');
        this.roleid = +paramMap.get('roleid');
        this.meetingform.patchValue({ institutionId: this.institutionid, fromDate: this.currentdate });
        this.institutionid = +paramMap.get('id');
        this.setPermissions();
        this.getInstitutions();
        this.search();
      }
    });
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];

    this.memberService.timestamp.subscribe(t => {
      if (t) {
        this.search();
      }
    });
  }


  getInstitutions() {
    if (this.institutionlist?.length === 0) {
      this.institutionlist = [];
      this.institutionsService.getInstitutions().subscribe(response => {
        if (response) {
          response.forEach(element => {
            const inst = { id: element.id, shortname: element.shortName, name: element.name };
            this.institutionlist.push(inst);
          });
          const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK', 'RR', 'SOFT1', 'SOFT2', 'SGL1', 'SL1'];
          this.institutionlist = this.institutionlist.filter(x => {
            return removelist.indexOf(x.shortname) === -1;
          });
          this.institutionlist = this.institutionlist.sort((a, b) => {
            return SortService.cmpStringsWithNumbers(a.shortname, b.shortname, false);
          });
        }
      }
      );
    }
  }

  onSubmit() {
  }

  clear() {
    this.meetingform?.reset();
    this.meetingresult = [];
  }

  search() {
    if (this.roleid) {
      this.meetingform.patchValue({ roleId: this.roleid });
      const searchdata = this.meetingform.value;
      if (searchdata.institutionId === null) {
        searchdata.institutionId = "";
      }
      this.meetingsService.getMeetingReportAsync(searchdata as any).subscribe(data => {
        this.meetingresult = data;
      });
    }
  }

  exportToCSV() {
    this.meetingresult.forEach(data => {
      data.meetingDate = this.datePipe.transform(data.meetingDate, 'yyyy-MM-dd');
    });
    this.meetingresult.forEach(r => {
      delete r['institutionId'];
      delete r['currentUserCanEdit'];
    });
    let firstrow = '';
    let reportdata;
    if (this.meetingform.get('institutionId').value !== null && this.meetingform.get('institutionId').value !== '') {
      firstrow = 'Id;Mötesdatum;Rubrik;Kommentar;Mötestyp;Kortnamn;Namn;Ort;Närvarande;Gäster;Egna';
      reportdata = this.meetingresult;
    } else {
      firstrow = 'Id;Mötesdatum;Rubrik;Kommentar;Mötestyp;Kortnamn;Namn;Ort;';
      this.meetingresult.forEach(x => {
        delete x.numberOfAttendances;
        delete x.numberOfGuestAttendances;
        delete x.numberOfOwnInstitutionAttendances;
      });
    }
    const filnamn = 'OF_Mötesrapport_' + this.chooseninstitution;
    CSVDataService.exportToCsv(filnamn + '.csv', this.meetingresult, firstrow);
  }

  onChange(event) {
    this.setPermissions();
    this.chooseninstitution = (event.target.options[event.target.options.selectedIndex].text).replace(/ /g, '_');
  }

  sortData(sort: Sort) {
    const data = this.meetingresult.slice();
    if (!sort.active || sort.direction === '') {
      this.meetingresult = data;
      return;
    }

    this.meetingresult = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'meetingDate': return this.compare(a.meetingDate, b.meetingDate, isAsc);
        case 'attendants': return this.compare(a.numberOfAttendances, b.numberOfAttendances, isAsc);
        case 'issue': return this.compare(a.issue, b.issue, isAsc);
        case 'comment': return this.compare(a.comment, b.comment, isAsc);
        case 'meetingTypeName': return this.compare(a.meetingTypeName, b.meetingTypeName, isAsc);
        case 'institutionShortName': return SortService.cmpStringsWithNumbers(a.institutionShortName, b.institutionShortName, isAsc);
        case 'institutionName': return this.compare(a.institutionName, b.institutionName, isAsc);
        // tslint:disable-next-line:max-line-length
        case 'institutionVisitingAddressCity': return this.compare(a.institutionVisitingAddressCity, b.institutionVisitingAddressCity, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  viewMeetingAndAttendances(meetingid: number, institutionid: number) {
    // tslint:disable-next-line:max-line-length
    this.router.navigate(['/meetings/meetings/meetingdetails/id/', meetingid], { queryParams: { viewmode: true, institutionid: institutionid } });
  }

  addMeeting() {
    this.addmeetingview = true;
    const institution = this.institutionlist.find(i => i.id === Number(this.meetingform.get('institutionId').value));
    this.institutiondata = {
      id: institution.id,
      shortname: institution.shortname,
      name: institution.name
    };
  }

  closeAddMeeting(evt) {
    this.addmeetingview = false;
    this.search();
  }
}
